import { Tag as AntDTag, TagProps as AntDTagProps } from 'antd';
import React from 'react';

import './tag.scss';

interface TagProps extends AntDTagProps {
    isReverse?: boolean;
    size?: string;
    border?: boolean;
}

const Tag: React.FC<TagProps> = ({ isReverse, size, icon, border, ...props }) => {
    const classes = [];
    if (isReverse) {
        classes.push('rain-tag-reverse');
    }

    if (size === 'large') {
        classes.push('rain-tag-large');
    }

    // This causes the tag to render as a circle if it contains only an icon
    if (icon && !props.children) {
        classes.push('rain-tag-icon');
    }

    if (border) {
        classes.push('rain-tag-border');
    }

    return (
        <AntDTag className={classes.join(' ')} icon={icon} {...props}>
            {props.children}
        </AntDTag>
    );
};

export default Tag;
